import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription, zip } from 'rxjs';
import { FeatureFlagService } from '../services/feature-flag/feature-flag.service';
import { forLifeOf, LifecycleAware } from '../utilities/rxjs.helpers';

@LifecycleAware()
@Directive({
    selector: '[featureFlag]'
})
export class FeatureFlagDirective implements OnInit, OnDestroy {
    @Input() public featureFlagMissing?: TemplateRef<any>;
    private _hasEmbeddedView = false;
    private _featureFlagsSubscription: Subscription;
    private _featureFlags: string[];

    constructor(
        public featureFlagService: FeatureFlagService,
        private _templateRef: TemplateRef<any>,
        private _viewContainerRef: ViewContainerRef
    ) {}

    @Input()
    public set featureFlag(featureFlagOrFlags: string | string[]) {
        let featureFlags = [] as string[];
        if (typeof featureFlagOrFlags === 'string') {
            featureFlags.push(featureFlagOrFlags);
        } else {
            featureFlags = featureFlagOrFlags as string[];
        }
        this._featureFlags = featureFlags;

        if (!featureFlags || !featureFlags.length) {
            return;
        }

        const featureFlagsAreOnStream = zip(
            ...featureFlags.map((featureFlag) => this.featureFlagService.isOn(featureFlag))
        );

        if (this._featureFlagsSubscription) {
            this._featureFlagsSubscription.unsubscribe();
        }

        this._featureFlagsSubscription = featureFlagsAreOnStream
            .pipe(forLifeOf(this))
            .subscribe((areOn) => {
                if (areOn.every((isOn) => isOn)) {
                    if (!this._hasEmbeddedView) {
                        this._viewContainerRef.createEmbeddedView(this._templateRef);
                        this._hasEmbeddedView = true;
                    }
                } else {
                    this._viewContainerRef.clear();
                    this._hasEmbeddedView = false;

                    if (!!this.featureFlagMissing) {
                        this._viewContainerRef.createEmbeddedView(this.featureFlagMissing);
                        this._hasEmbeddedView = true;
                    }
                }
            });
    }

    public ngOnInit(): void {
        if ((!this._featureFlags || !this._featureFlags.length) && !this._hasEmbeddedView) {
            this._viewContainerRef.createEmbeddedView(this._templateRef);
            this._hasEmbeddedView = true;
        }
    }

    public ngOnDestroy(): void {}
}
